var exports = {
  "S": "xaf9ae18d--37dfe7--desktop-banner",
};

module.exports = exports;
